import { Component, input } from '@angular/core';

@Component({
  selector: 'spl-ui-spinner',
  imports: [],
  templateUrl: './spinner.html',
  styleUrl: './spinner.scss',
})
export class SplUiSpinner {
  readonly diameter = input('25');
}
